<template>
    <transition name="fade">
        <div id="editor_trace" v-if="showEditor" @click.self="maskClickEvn">
            <div class="editor_trace">
                <div class="editor_trace1">
                    <div class="flex">
                        <span class="t-m-r-20">AI润色</span>
                        <textLoading v-if="streamStatus"></textLoading>
                    </div>
                    <img class="cursor_1" src="../assets/image/icon_close.png" alt="" @click="closePopup">
                </div>
                <div class="editor_trace2">
                    <div class="editor_trace3">
                        <div class="editor_trace4_1">
                            <div class="editor_polish">
                                <div class="editor_polish_1">
                                    <span>*</span>需要润色的内容
                                    <!-- <span class="t-p-l-10 t-font-14" style="color: var(--tech-primary);"><i class="el-icon-document-copy"></i>粘贴</span> -->
                                </div>
                                <div class="editor_polish_2">
                                    <!-- <el-input type="textarea" :autosize="{ minRows: 4 }" :placeholder="placeholder"
                                        v-model="polishText">
                                    </el-input> -->
                                    <editBox v-model="polishText" :placeholder="placeholder"></editBox>
                                </div>

                            </div>
                            <div class="editor_polish2">
                                <div class="editor_polish_1 t-m-t-20">
                                    要求(非必填)
                                </div>
                                <div class="editor_polish_2">
                                    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" show-word-limit
                                        maxlength="5000" placeholder="请输入下文故事情节，AI会按照您的思路进行创作" v-model="requireText">
                                    </el-input>
                                </div>
                            </div>
                            <div class="editor_polish1" v-if="isDj">
                                <div class="editor_polish_1">
                                    风格
                                </div>
                                <div class="editor_polish1_1">
                                    <div class="cursor_1" v-for="(item, i) in styleList" :key="i" @click="select(i)"
                                        :class="styleIndex == i ? 'editor_polish1_2 editor_polish1_3' : 'editor_polish1_2'">
                                        {{ item }}
                                    </div>
                                    <el-input type="text" placeholder="请输入自定义风格" v-model="styleText" maxlength="20"
                                        show-word-limit @input="getStyle">
                                    </el-input>
                                </div>
                            </div>

                        </div>
                        <div class="editor_trace3_3">
                            <div class="editor_trace3_4 cursor_1" @click="aiTrace">AI生成</div>
                        </div>
                    </div>
                    <div class="editor_trace4" v-if="traceShow" style="position: relative;">
                        <div class="editor_trace4_1" ref="editortrace4">
                            <el-input v-if="!streamStatus" type="textarea" :autosize="{ minRows: 8 }"
                                :placeholder="placeholder" v-model="polishCotent">
                            </el-input>
                            <!-- <editBox v-if="!streamStatus" v-model="markedPolishCotent"></editBox> -->
                            <div v-else v-html="markedPolishCotent"></div>
                        </div>
                        <!-- 停止生成按钮 -->
                        <AIStopCreate :hide="streamStatus" emit @stop="clearTimers" bottom="80px"></AIStopCreate>
                        <div class="editor_trace4_2">
                            <div class="editor_trace3_4 cursor_1" @click="replace">替换原文</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import api from '@/api/api';
import data from '@/assets/data'
import { paste } from '@/utils/utils'
import { EventBus } from '@/utils/eventBus'
import editBox from '@/components/edit_box.vue' // 文本编辑框
import textLoading from '@/components/text_loading.vue';
export default {
    props: {
        maskClick: {
            type: Boolean,
            default: true
        },
        isDj: Boolean
    },
    components: {
        editBox, textLoading
    },
    beforeDestroy() {
        this.clearTimers()
    },
    data() {
        return {
            showEditor: false, //显示隐藏
            traceShow: false, //显示右侧
            polishText: '', //复制需要润色的内容
            polishCotent: '',//润色后接口返回的原装内容
            markedPolishCotent: "", //处理润色后的接口内容
            styleList: data.styleList, //风格列表
            styleIndex: 0,
            styleText: '',//自定义风格
            requireText: '', //要求
            placeholder: '请粘贴需要润色的内容，必须是从正文内容中复制的完整段落内容',
            streamStatus: false, // 流式请求 false请求结束 true请求
            streamIndex: 0, // 流式请求下标
            debounceTimer: null, // 防抖定时器
            typingTimer: null, // 打字效果定时器
            isStop: false,
            scriptId: '',//短剧id
        }
    },
    methods: {
        //销毁定时器
        clearTimers(status) {
            console.log('销毁定时器');
            this.streamIndex = 0
            this.streamStatus = false
            clearTimeout(this.debounceTimer)
            clearInterval(this.typingTimer)
        },
        //AI生成润色
        aiTrace() {
            // console.log('this.polishText原生=',this.polishText)
            // console.log('this.polishText去trim（）前后空格后=',this.polishText.trim())
            // console.log('原生去除标签=',this.stripHtmlTags(this.polishText))
            // console.log('trim（）去除标签=',this.stripHtmlTags(this.polishText.trim()))
            const trimmedPolishText = this.polishText;
            if (trimmedPolishText === '') {
                this.$message.warning('请输入润色的内容！');
                return;
            }
            const polishItem = {
                content: this.stripHtmlTags(trimmedPolishText),
                // style: this.styleText.trim() === '' ? this.styleList[this.styleIndex] : this.styleText,
                requirement: this.requireText.trim() === '' ? '' : this.requireText
            };
            //短剧需要润色风格
            if (this.isDj) {
                polishItem.scriptId = this.scriptId
                polishItem.style = this.styleText.trim() === '' ? this.styleList[this.styleIndex] : this.styleText
            }
            this.polishCotent = ''
            this.markedPolishCotent = ''
            this.AIWrite({
                length: this.isDj ? '短剧' : '中',
                haveId: false,
                djold: this.isDj,
                type: this.isDj ? 'djrs' : 'xsrs',
                params: polishItem,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                    this.traceShow = true
                },
            })
            // api.novelHelpWrite('xsrs', polishItem).then((res) => {
            //     if (res.code == 200) {
            //         this.streamStatus = true
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //         this.traceShow = true
            //     }else{
            //          this.$message.warning(res.msg)
            //     }
            // })
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer)
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length
                            let combinedText = ''
                            for (let i in res.data) {
                                if (res.data[i] !== '[DONE]') {
                                    combinedText += res.data[i]
                                } else if (res.data[i] === '[ERROR]') {
                                    this.$message.error('AI生成失败')
                                    this.clearTimers()
                                    return
                                }
                            }
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.clearTimers()
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    this.$message.success('AI生成完成！')
                                    return
                                }
                                this.getStreamContent(id)
                            })
                        } else {
                            this.getStreamContent(id)
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTimers()
                    }
                })
            }, 500)
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0
            if (this.typingTimer) {
                clearInterval(this.typingTimer)
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    this.polishCotent += text[index]
                    this.markedPolishCotent = this.polishCotent.replace(/\n/g, '<br>')
                    index++
                    this.$nextTick(() => {
                        const container = this.$refs.editortrace4;
                        if (container) {
                            container.scrollTop = container.scrollHeight; // 直接滚动到底部
                        }
                    });
                } else {
                    clearInterval(this.typingTimer)
                    if (callback) {
                        callback()
                    }
                }
            }, 20)
        },
        // 打开
        open(params) {
            this.showEditor = true
            this.traceShow = false
            this.polishCotent = ''
            this.polishText = ''
            this.requireText = ''
            if (this.isDj) {
                this.scriptId = params.scriptId
                this.getTags()
            }
        },
        getTags() {
            api.tags({ writerType: "novel_rewrite", paramKey: "xsgxfg" }).then(res => {
                if (res.code == 200) {
                    if (res.data) {
                        this.styleList = res.data.split(',')
                    }
                }
            })
        },
        //蒙层点击事件
        maskClickEvn() {
            if (this.maskClick) return
            this.closePopup();
        },
        // 关闭
        closePopup() {
            if (this.streamStatus) {
                this.$message.warning('请等待生成完成！')
                return
            }
            this.clearTimers();
            this.showEditor = false
        },
        // 替换原文
        replace() {
            if (this.streamStatus) {
                this.$message.warning('请等待生成完成！')
                return
            }

            EventBus.$emit('replace', {
                text: this.stripHtmlTags(this.polishText),
                content: this.markedPolishCotent
            })
            this.showEditor = false
        },
        //选择风格
        select(i) {
            this.styleIndex = i
            this.styleText = ''
        },
        getStyle() {
            if (this.styleText.trim() === '') {
                this.styleIndex = 0
            } else {
                this.styleIndex = null
            }
        }
    }
}
</script>

<style>
#editor_trace {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor_trace {
    height: 480px;
    background: #FFFFFF;
    border-radius: 10px;
}

.editor_trace1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 18px;
    color: #111111;
    height: 65px;
    padding: 0 30px;
    border-bottom: 1px solid #E6EBF0;
}

.editor_trace1 img {
    width: 21px;
    height: 21px;
}

.editor_trace2 {
    display: flex;
    height: calc(100% - 65px);
}

.editor_trace3 {
    width: 525px;
}

.editor_polish_1 {
    font-weight: bold;
    font-size: 16px;
    color: #111111;
    margin-bottom: 15px;
}

.editor_polish_1 span {
    color: #FF0000;
}

.editor_polish_2 {
    height: 100px;
    background-color: #FAFAFA;
    padding: 10px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.editor_polish_2 .el-textarea {
    height: 100%;
}

.editor_polish_2 textarea {
    height: auto !important;
}

.editor_polish_2 .el-input__count {
    background: transparent !important;
}

.editor_polish2 .editor_polish_2 .el-textarea__inner,
.editor_polish .editor_polish_2 .el-textarea__inner {
    font-size: 15px;
    color: #111111;
    border: none;
    resize: none;
    padding: 0;
    background-color: #FAFAFA;
}


.editor_polish1 {
    margin-top: 10px;
}

.editor_polish1_1 {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.editor_polish1_2 {
    width: calc((100% - 20px) / 3);
    height: 38px;
    line-height: 38px;
    text-align: center;
    border-radius: 4px;
    background: #FAFAFA;
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 15px;
    color: #111111;
}

.editor_polish1_2:nth-child(3n) {
    margin-right: 0;
}

.editor_polish1_3 {
    color: var(--tech-primary);
    background-color: var(--tech-table-bg);
}

.editor_polish1_1 .el-input__inner {
    border: none;
    background-color: var(--tech-table-bg);
}

.editor_polish1_1 .el-input .el-input__count .el-input__count-inner {
    background-color: var(--tech-table-bg);
}

.editor_trace4_1 .el-textarea__inner {
    background-color: #FFFFFF;
}

.editor_trace3_3 {
    width: 100%;
    height: 73px;
    border-top: 1px solid #E6EBF0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

.editor_trace3_4 {
    width: 125px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    background: var(--tech-primary);
    border-radius: 8px;
    font-size: 15px;
    color: #FFFFFF;
}

.editor_trace4 {
    width: 525px;
    height: 100%;
    border-left: 1px solid #E6EBF0;
}

.editor_trace4_1 {
    height: calc(100% - 84px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 15px 30px;
}

.editor_trace4_2 {
    width: 100%;
    height: 73px;
    border-top: 1px solid #E6EBF0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>